import ApiClient from '@/domain/core/utils/apiClient'
import client_core from '@/services/clients/client_core'

const client = new ApiClient(client_core)

export default {
    async fetchStatus() {
        return await client.get('/dashboard/v2/user-status/status/')
    }
}
